import hyperdom from 'hyperdom'

export default class Sidebar {
  constructor ({
    config,
    summary,
    user,
    displayFaq,
    showEmailQuote,
  }) {
    this.config = config
    this.summary = summary
    this.user = user
    this.displayFaq = displayFaq
    this.showEmailQuote = showEmailQuote
  }

  render () {
    return <div class='o-sidebar'>
      {this.renderFAQ()}
      {this.summary}
      {this.renderReassurance()}
    </div>
  }

  renderFAQ () {
    return <div class='faq-container'>
      <button
          id='faq-button'
          type="button"
          onclick={(ev) => { ev.preventDefault(); this.displayFaq() }}
          className="btn-secondary-outline faq-button"
          data-item-type='General Interaction'
          data-item-name='faq-cta'
      >
      FAQs
      </button>
    </div>
  }

  renderReassurance () {
    return <div class='reassurance'>
      {
        this.user.loaded && this.config.features.emailQuote
          ? <div class='reassurance__item'>
            <h2 class='reassurance__heading'>E-mail trip details</h2>
            <div class='reassurance__content'>
              <p>Send the above trip price details to your inbox</p>
              <a class='show-email-quote' data-id="email-quote" href='#emailQuote' onclick={(ev) => { ev.preventDefault(); this.showEmailQuote() }}>E-mail trip details</a>
            </div>
          </div>
          : ''
      }
      <div class='reassurance__item'>
        <h2 class='reassurance__heading'>Why book with us?</h2>
        <ul class='reassurance-list'>
          {
            (this.config.bookingBenefits || this.config.why).map(reason => {
              return <li class='reassurance-list__item'>{reason}</li>
            })
          }
        </ul>
        {
          (this.config.bookWithConfidence && this.config.bookWithConfidence.moreLink) ?
            <a class='find-out-more-link' id='book-with-confidence-banner_show-more-btn' href={this.config.bookWithConfidence.moreLink.url} target='_blank'>{this.config.bookWithConfidence.moreLink.text}</a>
            : ''
        }
      </div>
    </div>
  }
}
